import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import config from '../../config';
import { HOME, TRIP_PLAN, CREATE_TRIP, UPDATE_TRIP, USE_TRIP_URL } from '../../constants/ROUTER_PATH_TITLE';

import TripList from '../../components/TripList/TripList';

import useUser from '../../hooks/useUser';
import useTrip from '../../hooks/useTrip';
import AppNav from '../../App/AppNav/AppNav';

const HomePage = () => {
  const { loadingTripReferences, tripReferences, userTripReferencesFetch } = useUser();
  const { loadingTripDelete, tripDelete, tripClear } = useTrip();

  const history = useHistory();
  document.title = `${HOME.TITLE}`;

  useEffect(() => {
    if (config.HIDE_HOME) {
      history.replace(USE_TRIP_URL.PATH);
    } else if (!tripReferences)
      userTripReferencesFetch().then(
        () => {},
        () => {},
      );
  }, [history, tripReferences, userTripReferencesFetch]);

  useEffect(() => {
    tripClear();
  }, [tripClear]);

  const cardClicked = (tripHash: string) => {
    history.push(`${TRIP_PLAN.PATH}/${tripHash}`);
  };

  const cardEditClicked = (tripHash: string) => {
    history.push(`${UPDATE_TRIP.PATH}/${tripHash}`);
  };

  const cardDeleteClicked = async (tripHash: string) => tripDelete(tripHash);
  return (
    <>
      <AppNav header={HOME.HEADER} />
      <div className="container mt10">
        <div className="row center">
          <TripList
            tripReferences={tripReferences || []}
            loadingTripReferences={loadingTripReferences || loadingTripDelete}
            cardClicked={cardClicked}
            cardEditClicked={cardEditClicked}
            cardDeleteClicked={(hash: string) => cardDeleteClicked(hash).then(() => true)}
            tripCreateClicked={() => history.push(CREATE_TRIP.PATH)}
          />
        </div>
      </div>
    </>
  );
};

export default HomePage;
